// extracted by mini-css-extract-plugin
module.exports = {"container":"_32bbee5fda--container--V6Ruf","link":"_32bbee5fda--link--bjxeF","title":"_32bbee5fda--title--fJOs7","dot":"_32bbee5fda--dot--dXNXB"};